import { createReducer, on } from '@ngrx/store';

import { IRevenue } from 'src/app/shared/interfaces/revenue/irevenue';
import { loadRevenue, loadRevenueSuccess, saveRevenueSuccess } from './revenue.actions';

export interface IRevenueState {
  lista: IRevenue[];
  isLoading: boolean
}

const initialState: IRevenueState = {
  lista: [],
  isLoading: false
};

export const revenueReducer = createReducer(
  initialState,
  on(loadRevenue, (state) => ({
    ...state,
    isLoading: true
  })),
  on(loadRevenueSuccess, (state, { lista }) => ({
    ...state,
    lista: [...lista],
    isLoading: false
  })),

  on(saveRevenueSuccess, (state, { revenue }) => ({
    ...state,
    lista: [...state.lista, revenue],
  }))
);
